import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';
import { Choferes } from '../../core/models';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ChoferService {
	private viajes: Choferes[] = [];

	constructor(private _apiService: ApiService) {}

	/* GET */
	getEstadoChofer(nroDocumento: string, sexo: string, fechaControl: string) {
		return this._apiService.get(`/choferes/estadoChofer`, {
			nroDocumento: nroDocumento,
			sexo: sexo,
			fechaControl: fechaControl,
		});
	}

	/* POST */
	post(choferes: Choferes) {
		return this._apiService.post('choferes', choferes);
	}

	/* PUT */
	put(choferes: Choferes) {
		return this._apiService.put(`choferes/${choferes.id}`, choferes);
	}
}
